export default __webpack_public_path__ + "static/media/Pong.65d30405.png";